/* eslint-disable */
import {
  memoEval,
  sceneEntityObjectPropertiesComponent,
  sceneEntityRemoteObjectComponent,
} from '@salsita-ai/platform-project-sdk/domain'

import { attachComponent } from '../implementation.js'

export const baseFourLegCombinedComponents = [
  attachComponent
    .withComponent(sceneEntityRemoteObjectComponent, 'base', true)
    .withAlias('BaseFourLegCombined')
    .attach(
      memoEval(
        // @ts-ignore
        self =>
          // keep deps on a separate line so @ts-ignore only covers the parameter
          [self.$fileUrl, self.$objectName],
        ($fileUrl, $objectName) => ({
          fileUrl: $fileUrl,
          objectName: $objectName,
          dimensionUnit: 'inch',
        })
      )
    ),

  attachComponent
    .withComponent(sceneEntityObjectPropertiesComponent, 'base', true)
    .withAlias('BaseFourLegCombined')
    .attach(
      memoEval(
        // @ts-ignore
        self =>
          // keep deps on a separate line so @ts-ignore only covers the parameter
          [
            self.$width,
            self.$widthScaleZero,
            self.$widthScaleOne,
            self.$length,
            self.$lengthScaleZero,
            self.$lengthScaleOne,
          ],
        ($width, $widthScaleZero, $widthScaleOne, $length, $lengthScaleZero, $lengthScaleOne) => ({
          morphTargetInfluences: {
            width: {
              value: $width,
              scaleZero: $widthScaleZero,
              scaleOne: $widthScaleOne,
            },
            length: {
              value: $length,
              scaleZero: $lengthScaleZero,
              scaleOne: $lengthScaleOne,
            },
          },
        })
      )
    ),
]
